// src/pages/couriers/components/DeleteModal.jsx
import React from 'react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import { AlertCircle, X, Trash2, RefreshCw } from 'lucide-react';
import styles from './DeleteModal.module.css';

const DeleteModal = ({
  isOpen,
  onClose,
  courier,
  onConfirm,
  isSubmitting
}) => {
  const { t } = useLocalization();

  if (!isOpen || !courier) return null;

  const hasRelatedRecords = courier.hasRelatedRecords;
  const relatedCounts = courier.relatedRecordCounts;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>
            <AlertCircle size={20} />
            {t('couriers.confirmRemoval')}
          </h2>
          <button onClick={onClose} className={styles.closeButton}>
            <X size={20} />
          </button>
        </div>

        <div className={styles.modalContent}>
          {hasRelatedRecords ? (
            <>
              <p className={styles.errorText}>
                {t('couriers.cannotRemove')} <strong>{courier.accountName}</strong> {t('couriers.hasRelatedRecords')}
              </p>
              <ul className={styles.relatedRecordsList}>
                {relatedCounts.packingBatches > 0 && (
                  <li>{relatedCounts.packingBatches} {t('couriers.packingBatches')}</li>
                )}
                {relatedCounts.orders > 0 && (
                  <li>{relatedCounts.orders} {t('couriers.orders')}</li>
                )}
                {relatedCounts.assignmentRules > 0 && (
                  <li>{relatedCounts.assignmentRules} {t('couriers.assignmentRulesCount')}</li>
                )}
              </ul>
              <p className={styles.warningText}>
                {t('couriers.removeRelatedRecordsFirst')}
              </p>
            </>
          ) : (
            <>
              <p>
                {t('couriers.removeConfirmation')} <strong>{courier.accountName}</strong>?
              </p>
              <p className={styles.warningText}>
                {t('couriers.removeWarning')}
              </p>
            </>
          )}
        </div>

        <div className={styles.modalFooter}>
          <button
            onClick={onClose}
            className={styles.secondaryButton}
            disabled={isSubmitting}
          >
            {hasRelatedRecords ? t('couriers.close') : t('couriers.cancel')}
          </button>
          {!hasRelatedRecords && (
            <button
              onClick={onConfirm}
              className={styles.dangerButton}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <RefreshCw size={16} className={styles.spinning} />
                  {t('couriers.removing')}
                </>
              ) : (
                <>
                  <Trash2 size={16} />
                  {t('couriers.removeCourier')}
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;